export default __webpack_public_path__ + "assets/rockhopper.png";